import { render } from "./ProjectsRanking.vue?vue&type=template&id=377e6b96"
import script from "./ProjectsRanking.vue?vue&type=script&lang=js"
export * from "./ProjectsRanking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__